import React from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import Grid from "@mui/material/Grid2";
import "./powerBI.css"

const PowerBIReport = () => {

  const powerBIData = 
  JSON.parse(
    localStorage.getItem("pbiconfig") || "null",
);
  const embedConfig = {
    type: "report", 
    id: powerBIData.reportConfig[0].reportId, 
    embedUrl:powerBIData.reportConfig[0].embedUrl,
    accessToken: powerBIData.accessToken,
    tokenType: models.TokenType.Embed, 
    settings: {
      panes: {
        filters: {
          visible: false, 
        },
        pageNavigation: {
          visible: true, 
        },
      },
      background: models.BackgroundType.Transparent, 
    },
  };
  

  const eventHandlers = new Map([
    [
      "loaded",
      () => {
        console.log("Report loaded successfully!");
      },
    ],
    [
      "rendered",
      () => {
        console.log("Report rendered successfully!");
      },
    ],
    [
      "error",
      (event:any) => {
        console.error("Error occurred:", event.detail);
      },
    ],
  ]);

  return (
    <Grid sx={{ height: '90vh', display: 'flex', flexDirection: 'column' }}>
    <Grid
      sx={{
        flex: 1,
        mt: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        background: '#fff',
        boxShadow:
          '0px 2px 4px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12)',
        borderRadius: '8px',
      }}
    >
      <div style={{ height: '100%', width: '100%' }}>
        <PowerBIEmbed
          embedConfig={embedConfig}
          eventHandlers={eventHandlers}
          cssClassName="powerbi-frame"
          getEmbeddedComponent={(embeddedReport) => {
            console.log('Embedded component instance:', embeddedReport);
          }}
        />
      </div>
    </Grid>
  </Grid>
  
  );
};

export default PowerBIReport;
